<!--  no need for this for now 

@click="pageclick"
@getPagePoint="currentpage"
@_getVisiblePages="currentpage"
@mousescroll="currentpage"
@hover="currentpage"
@getPageView="whatpage"
:pagechanging="whatpage"
@pagenumberchanged="whatpage"
@_scrollIntoView="whatpage"
@scrollPageIntoView="whatpage"
@focus="whatpage"
@on="page"
@open="openHandler"
@pages-rendered="pagesRenderedHandler"
:page-number="page"
@scrollPageIntoView="whatpage"
:click="showcontract()"
:click="whatpage()"
@getPageView="whatpage()"
:mouseup="whatpage()"
-->
<!--  https://xd.adobe.com/view/043c2377-c87d-41bf-b429-2ffe2322e7ce-516f/specs/ 
https://docs.google.com/presentation/d/1UivJFMHQGhHTr5JY2Nq057cU3yz4bjN19aF1Y7TOsnw/edit#slide=id.g13fb061f812_3_1
https://docs.google.com/presentation/d/13UsZSW6pwkxbykyikLyZZ6SMvyENk4zDX6HOSUztTt4/edit#
-->
<template>
  <div id="contract-draft" class="clearfix noto-sans darkblue px2 mb4">
    <div class="col-12">
          <div class="clearfix ">
            <div id="pagetitle" class="col-12 mt2 px0 flex justify-between items-center">
                <p class="h1 regular line-height-2 my3 ">UDKAST KONTRAKT</p>
            </div>
            <div class="height-100vh" v-if="loading">
              <Loading></Loading>
            </div>
            <div class="contract-wizard" v-else>
              <div class="py1"></div>
              <!-- <div class="flex items-center px2 mb4" v-if="activeWizard == 1">
                <div class="mr1">
                  <p class="h6 darkblue mb0">{{'select'}}:</p>
                </div>
                <! -- Select template -- >
                <! --  eslint-disable -- >
                <el-select v-model="selectedContractTemplateId" :placeholder="'select'" filterable :no-match-text="'no_data'" :no-data-text="'no_data'" @change="contractTemplateChanged()">
                  <el-option
                    v-for="(template, index) in contractWizardsData"
                    :key="index"
                    :label="template.NAME"
                    :value="template.TEMPLATE_ID"
                    v-if="index == 0">
                  </el-option>
                </el-select>
                <!- -  eslint-enable -- >
              </div> -->
              <form-wizard id="contractDraftWizard" ref="contractDraftWizard" :start-index="startIndex" shape="circle" color="rgba(25, 163, 192, 1.0)" error-color="rgba(207,0,15,1.0)" step-size="sm" finishButtonText="Bekræft" @on-change="wizardChanged">
                <tab-content title="Dine Info" class="contractTab-1 px3" :before-change="validateTab1">
                  <el-form :model="tab1Form" :rules="tab1formRules" ref="wizardtab1">
                      <p class="h2 darkblue semi-bold line-height-2 mt2">1. Aftaleparter</p>
                      <div class="py2">
                        <p class="h5 darkblue semi-bold line-height-2 my2">Håndværker</p>
                        <div class="flex flex-wrap">
                          <el-form-item label="Fornavn" prop="firstName" class="col-6 p0 pr1 xs-po">
                            <el-input v-model="tab1Form.firstName"></el-input>
                          </el-form-item>
                          <el-form-item label="Efternavn" prop="lastName" class="col-6 p0 pl1 xs-p0">
                            <el-input v-model="tab1Form.lastName"></el-input>
                          </el-form-item>
                        </div>
                        <!--  eslint-disable -->
                        <el-form-item label="Adresse" prop="address" class="">
                          <el-select class="col-12 p0 addressSelect" v-model="tab1Form.address" filterable :no-match-text="'no_data'" :no-data-text="'no_data'" >
                            <el-option :value="tab1Form.address">
                                  <span class="darkblue left">{{ tab1Form.address }}</span>
                                  <span class="darkblue right">
                                      <el-tooltip :content="'primary_address'" placement="top" effect="light">
                                        <img class="ml2" src="@/assets/images/svg/shop-dark.svg" width="20">
                                      </el-tooltip>
                                  </span>
                              </el-option>
                          </el-select>
                        </el-form-item>
                        <!--  eslint-enable -->
                      <div class="flex flex-wrap">
                        <div class="col-6 pl0 pr1">
                          <el-form-item label="Postnummer" prop="zip" class="">
                            <el-input class="col-12 p0"  v-model.number="tab1Form.zip" :min="1" :controls="false"></el-input>
                          </el-form-item>
                        </div>
                        <div class="col-6 pl1 pr0">
                          <el-form-item label="By" prop="city" class="">
                            <el-input v-model="tab1Form.city"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="flex flex-wrap">
                        <el-form-item label="Telefon" prop="telphone" class="col-6 p0 pr1 xs-p0">
                          <el-input class="col-12 p0" v-model.number="tab1Form.telphone" maxlength="8" :controls="false"></el-input>
                        </el-form-item>
                        <el-form-item label="E-mail" prop="email" class="col-6 p0 pl1 xs-p0">
                          <el-input v-model="tab1Form.email"></el-input>
                        </el-form-item>
                      </div>
                      <div class="flex flex-wrap">
                        <el-form-item label="CVR" prop="partnerCvr" class="col-6 p0 pr1 xs-p0">
                          <el-input class="col-12 p0" v-model.number="tab1Form.partnerCvr" :min="1" maxlength="8" :controls="false"></el-input>
                        </el-form-item>
                        <el-form-item label="Firmanavn" prop="partnerName" class="col-6 p0 pl1 xs-p0">
                          <el-input v-model="tab1Form.partnerName"></el-input>
                        </el-form-item>
                      </div>
                      <div>
                          <p class="h5 darkblue semi-bold line-height-2 my2">Forbruger</p>
                          <div>
                            <p class="m0">{{tab1Form.howmownerName}}</p>
                            <p class="m0">{{tab1Form.howmowneremal}}</p>
                            <p class="m0">{{tab1Form.howmownerphone}}</p>
                            <p class="m0">{{tab1Form.howmownerID}}</p>
                          </div>
                      </div>
                    </div>
                  </el-form>
                </tab-content>

                <!-- Price -->
                <!-- <tab-content title="Price" :route="!$route.query.editStep ? '?step=2&fromProject=true' : '?step=2&fromProject=true&editStep=' + $route.query.editStep" class="contractTab-2" :before-change="validateTab2"> -->
                <!-- <tab-content title="Pris" class="contractTab-2" :before-change="validateTab2">
                  <form action="#" class="">
                    <p class="h2 darkblue semi-bold line-height-2 mb3">2. Pris</p>
                    <div class="py2"></div>
                    <div class="col-12 px0 cloneFields hide">
                      <label>{{'email'}}</label>
                      <input
                        type="hidden"
                        class="p2 border mutedxd-border col-12"
                      />
                    </div>
                    <div class="mb3">
                      <div class="col-12 p0 border mediumgrey-border height-100">
                        <! -- eslint-disable -- >
                        <div class="p2" v-for="(item, index) in Object.keys(officialEnterpriseArr)" :key="index">
                          <h3 class="cyprus mb2">{{(index + 1)}}. {{primaryproductindustryname[item]}}</h3>
                          <div v-for="(jobindustry,index2) in officialEnterpriseArr[item]" :key="index2">
                            <div class="flex items-center">
                              <h4 class="cyprus my2 pl2">{{index + 1}}.{{index2 + 1}} {{' ' + itemsjobindustry[jobindustry.JOB_INDUSTRY]}}</h4>
                              <span class="ml-auto semi-bold pr4">{{Number(jobindustry.TOTAL_VAT_FEE).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:2})}}</span>
                            </div>
                            <div class="px3 flex" v-for="(desc, index3) in Object.values(jobindustry.SERIES)" :key="index3" v-if="jobindustry.SERIES !== null && desc !== ''">
                                <span class="pr1 col-1 xs-col-2">{{(index + 1)}}.{{index2 + 1}}. {{index3 + 1}}</span>
                                <div class="h6 m0">
                                  <span>{{desc}}</span>
                                </div>
                            </div>
                            <div class="px3 flex" v-for="(desc, index4) in jobindustry.SERIES_ORIGINAL" :key="index4" v-else>
                                <span class="pr1 col-1 xs-col-2">{{(index + 1)}}.{{index2 + 1}}. {{index4 + 1}}</span>
                                <div class="h6 m0">
                                  <span>{{desc}}</span>
                                </div>
                            </div>
                          </div>
                        </div>
                        <! -- eslint-enable -- >
                      </div>
                      <div class="col-12 flex mt3 p2 px4"><p class="m0 p0 semi-bold">Inklusive moms og gebyrer</p><p class="semi-bold h5 ml-auto">{{Number(maintotal).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:2})}}</p></div>
                    </div>
                  </form>
                </tab-content> -->

                <!-- Dynamic contract tabs -->
                <!-- <tab-content :title="contractWizardStepsData.length > 5 ? wizard.label.length >= 10 ? wizard.label.substring(0, 10) + '...' : wizard.label : wizard.label.length >= 30 ? wizard.label.substring(0, 30) + '...' : wizard.label" :route="!$route.query.editStep ? '?step=' + (index + 3) + '&fromProject=true' : '?step=' + (index + 3) + '&fromProject=true&editStep=' + $route.query.editStep" :class="'contractTab-' + (index + 3)"  v-for="(wizard, index) in contractWizardStepsData" :key="index" :before-change="validateDynamicTabs"> -->
                <tab-content :title="contractWizardStepsData.length > 5 ? wizard.label.length >= 10 ? wizard.label.substring(0, 10) + '...' : wizard.label : wizard.label.length >= 30 ? wizard.label.substring(0, 30) + '...' : wizard.label" :class="'contractTab-' + (index + 2)"  v-for="(wizard, index) in contractWizardStepsData" :key="index" :before-change="validateDynamicTabs">
                  <!-- <p class="small cyprus line height-1 mb3 semi-bold">
                    {{wizard.Info}}
                  </p> -->
                  <p class="h2 darkblue semi-bold line-height-2 mb3">{{index + 3}}. {{wizard.Info}}</p>
                  <div class="mb4" v-for="(wizField, index1) in wizard.fields" :key="index1">
                    <!-- label -->
                    <p class="m0">
                      <label v-html="wizField.label.replace('{fee}', tab2Form.paymentStagesData.reduce((n, {price}) => n + price, 0))"></label>
                      <span class="red" v-if="wizField.mandatory == 1">*</span>
                      <el-tooltip placement="top" effect="light" v-if="wizField.help">
                        <div slot="content">
                          <p class="m0" v-html="wizField.help"></p>
                        </div>
                        <i class="shakespeare el-icon-info ml1"></i>
                      </el-tooltip>
                    </p>
                    <!-- Input text -->
                    <el-input class="col-12 p0 fields-id-value" :class="wizField.mandatory == 1 ? 'required' : null" :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value" :placeholder="wizField.place_holder " v-model="wizField.default_value" v-if="wizField.field == 2 && wizField.number == 0"></el-input>
                    <!-- Input number -->
                    <el-input-number class="col-12 p0 fields-id-value" :class="wizField.mandatory == 1 ? 'required' : null" :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value" :placeholder="wizField.place_holder " v-model="wizField.default_value" :controls="false" :min="0" v-else-if="wizField.field == 2 && wizField.number == 1"></el-input-number>
                    <!-- Radio -->
                    <el-radio-group class="col-12 p0 fields-id-value" :class="wizField.mandatory == 1 ? 'required' : null" :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value" v-model="wizField.default_value" fill="#19A3C0" v-else-if="wizField.field == 3">
                      <el-radio :label="option" v-for="(option, optionIndex) in wizField.values" :key="optionIndex">{{option}}</el-radio>
                    </el-radio-group>
                    <!-- Checkbox -->
                    <el-checkbox-group class="col-12 p0 fields-id-value" :class="wizField.mandatory == 1 ? 'required' : null" :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value" v-model="wizField.default_value" fill="#19A3C0" v-else-if="wizField.field == 4">
                      <el-checkbox :label="option" v-for="(option, optionIndex) in wizField.values" :key="optionIndex"></el-checkbox>
                    </el-checkbox-group>
                    <!-- Slider -->
                    <el-slider :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value" class="fields-id-value" :class="wizField.mandatory == 1 ? 'required' : null" v-model="wizField.default_value" :max="parseInt(10)" :step="1" v-else-if="wizField.field == 5">
                    </el-slider>
                    <!-- Select -->
                    <div class="col-12 p0 fields-id-value" :class="wizField.mandatory == 1 ? 'required' : null" :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value" v-else-if="wizField.field == 7">
                      <el-select :placeholder="wizField.place_holder " v-model="wizField.default_value" class="col-12 p0">
                        <el-option
                          v-for="(option, optionIndex) in wizField.values"
                          :key="optionIndex"
                          :label="option"
                          :value="option">
                        </el-option>
                      </el-select>
                    </div>
                    <!-- Input textarea -->
                    <div class="col-12 p0 fields-id-value" :class="wizField.mandatory == 1 ? 'required' : null" :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value" v-else-if="wizField.field == 8">
                      <el-input
                        type="textarea"
                        :rows="3" 
                        :placeholder="wizField.place_holder"
                        v-model="wizField.default_value">
                      </el-input>
                    </div>
                    <!-- Rating -->
                    <el-rate
                      :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value"
                      class="fields-id-value"
                      :class="wizField.mandatory == 1 ? 'required' : null"
                      :high-threshold="10"
                      :low-threshold="1"
                      v-model="wizField.default_value"
                      :max="10"
                      :icon-classes="iconClasses"
                      void-icon-class="el-icon-remove-outline"
                      :colors="colorClasses"
                      v-else-if="wizField.field == 9">
                    </el-rate>
                    <!-- <b-form-datepicker :placeholder="wizField.place_holder" :date-format-options="{ 'year': 'numeric', 'month': 'numeric', 'day': 'numeric' }" v-model="wizField.default_value" v-else-if="wizField.field == 10"></b-form-datepicker> -->
                    <el-date-picker
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      :placeholder="wizField.place_holder"
                      class="col-12 p0"
                      v-model="wizField.default_value"
                      v-else-if="wizField.field == 10">
                    </el-date-picker>
                  </div>
                </tab-content>

                <!-- Wizard footer -->
                <template slot="footer" slot-scope="props">
                  <div class="py3"></div>
                  <div class="flex col-12 p0 m0">
                    <button @click="props.prevTab()" class="outlined-primary-button h5 semi-bold m0 line-height-4 regular button-padding px3 py2" v-if="props.activeTabIndex > 0">
                      <span class="inline-block">Tilbage</span>
                    </button>
                    <button @click="props.nextTab()" :disabled="activeWizard === 2 && $route.query.fastTrackType === 'contract'" class="action-button h5 semi-bold m0 line-height-4 regular button-padding px3 py2 ml-auto">
                      <span class="inline-block">{{!props.isLastStep ? 'Næste' : 'Indsend'}}</span>
                    </button>
                  </div>
                </template>
              </form-wizard>
            </div>
          </div>
      </div>
      <div class="xs-hide py4"></div>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import VuePdfApp from 'vue-pdf-app'
import Simplert from 'vue2-simplert'
const Loading = () => import('@/components/Loading')
export default {
  name: 'contract-draft',
  components: {
    VuePdfApp,
    Simplert,
    Loading
  },
  data () {
    return {
      contractID: 11,
      contractStatus: '',
      contractpdflink: '/static/pdf/sample.pdf',
      contractdetails: [],
      homeownerID: 0,
      haaid: localStorage.getItem('haaid'),
      salesPersonbitrix: localStorage.getItem('id_token_portalbitrix'),
      loading: false,
      showMobile: false,
      info: [],
      activeWizard: null,
      contractWizardsData: [],
      selectedContractTemplateInfo: {},
      contractWizardStepsData: [],
      selectedContractTemplateId: '',
      startIndex: 0,
      dynamicTabSubmitted: false,
      currentProjectData: {},
      selectedmainTemplateId: null,
      tab1Form: {
        firstName: localStorage.getItem('name').split(' ')[0],
        lastName: localStorage.getItem('name').split(' ')[1],
        address: localStorage.getItem('address'),
        zip: Number(localStorage.getItem('zipcode')),
        city: localStorage.getItem('city'),
        telphone: Number(localStorage.getItem('partnerTelefon')),
        email: localStorage.getItem('email'),
        partnerCvr: Number(localStorage.getItem('Cvrnr')),
        partnerName: localStorage.getItem('CompanyName'),
        howmownerName: '',
        howmowneremal: '',
        howmownerphone: '',
        howmownerID: '',
        cvrInfo: {},
        cvrInfoLoading: false,
        submitted: false
      },
      tab1formRules: {
        firstName: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit fornavn',
          trigger: 'blur'
        }],
        lastName: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit efternavn',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit Adresse',
          trigger: 'blur'
        }],
        zip: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste dit postnummer',
          trigger: 'blur'
        }],
        city: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit by',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Du bedes indtaste en gyldig e-mail',
          trigger: 'blur'
        }],
        telphone: [{
          required: true,
          type: 'number',
          min: 1,
          max: 99999999,
          message: 'Du bedes indtaste en gyldig telnummer',
          trigger: 'blur'
        }],
        partnerCvr: [{
          required: true,
          type: 'number',
          min: 1,
          max: 99999999,
          message: 'Du bedes indtaste en cpr',
          trigger: 'blur'
        }],
        partnerName: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit firmanavn',
          trigger: 'blur'
        }]
      },
      tab2Form: {
        price: undefined,
        priceIsSwitched: false,
        invoiceWorK: '',
        invoiceWorKIsSwitched: false,
        recalculationIsSwitched: false,
        paymentStagesData: [{
          price: undefined,
          title: '',
          description: '',
          deadline: ''
        }],
        submitted: false
      },
      officialEnterpriseArr: {},
      selectedOfferInfoArr: [],
      total: null,
      normalContractPaymentStage: {},
      mainwizarproductarr: [],
      paymentStages: [],
      parentID: '',
      contractType: '',
      childprojects: [],
      primaryproductindustryname: {},
      itemsjobindustry: {},
      STEPactualValue: {},
      maintotal: null,
      jobList: []
    }
  },
  created () {
    // Fagentreprise
    // Hovedentreprise
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (localStorage.getItem('address') === null || localStorage.getItem('city') === null) {
      this.$message.error('Log venligst på igen for at opdatere dine tilbudsoplysninger')
      this.$router.push('/login')
    } else {
      this.getProjectDetails()
    }
    this.getallwizardproduct()
    this.gettaskbitrix()
    this.parentID = this.$route.query.parentID
    this.contractType = this.$route.query.contracttype
    this.industryID = this.$route.query.industryID
    this.offerType = this.$route.query.offertype
    this.childprojects = JSON.parse(this.$route.query.childprojects)
    this.tab1Form.telphone = localStorage.getItem('partnerTelefon')
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
  },
  mounted () {
  },
  methods: {
    getProjectDetails () {
      var projectid = this.$route.query.projectId
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/project/' + projectid, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.scrollTo('pagetitle')
            this.currentProjectData = res.data
            this.contractID = res.data.CONTRACT_ID
            this.contractStatus = res.data.CONTRACT_STATUS
            this.homeownerID = res.data.HOMEOWNER.ID
            this.jobList = res.data.JOBS_LIST
            this.tab1Form.address = res.data.ADDRESS.ADDRESS
            this.tab1Form.howmownerName = res.data.HOMEOWNER.NAME
            this.tab1Form.howmowneremal = res.data.HOMEOWNER.EMAIL
            this.tab1Form.howmownerphone = res.data.HOMEOWNER.MOBILE
            this.tab1Form.howmownerID = res.data.HOMEOWNER.ID
            // if (this.contractType === 'Fagentreprise') {
            //   this.getOfferAcceptedOfferfag(res.data.ID)
            // } else {
            this.getOfferAcceptedOffer(res.data.ID)
            // }
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
            this.loading = false
          }
        },
        response => {
          this.loading = false
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    getOfferAcceptedOffer (projectId, calculationid = 0) {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        projectId: projectId,
        status: 'accepted'
      }
      this.$http.get(this.$bitrixapi + 'partner/offers?status=accepted', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.selectedOfferInfoArr = res.filter(c => { return c.PROJECT_ID === Number(projectId) })
          this.getAcceptedOfferPrice(projectId, this.selectedOfferInfoArr[0].ACCEPTED_ENTERPRISE_INDUSTRY_IDS, Number(this.selectedOfferInfoArr[0]['PARTNER_PROFILE'].ID), Number(this.selectedOfferInfoArr[0]['ID']), calculationid)
        },
        response => {
          this.loading = false
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    getAcceptedOfferPrice (projectId, industryid, partnerid, offerid, calculationid = 0) {
      var proID = null
      if (this.contractType === 'Hovedentreprise') {
        proID = projectId
      } else {
        proID = this.parentID
      }
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPriceMinboligV2?contact_id=' + this.selectedOfferInfoArr[0].HOMEOWNER.ID + '&project_id=' + proID + '&calculation_id=' + calculationid, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          var result = []
          if (this.contractType === 'Hovedentreprise') {
            res.result.forEach(l => {
              if (Number(l.PARTNER_ID) === partnerid && Number(l.OFFER_ID) === Number(offerid) && l.JOB_INDUSTRY !== '1062') {
                result.push(l)
              } else if (Number(l.PARTNER_ID) === partnerid && Number(l.OFFER_ID) === Number(offerid) && l.JOB_INDUSTRY === 1062 && this.jobList.length === 1) {
                result.push(l)
              }
              this.totalmain += Number(l.TOTAL_VAT_FEE)
            })
          } else {
            res.result.forEach(l => {
              if (Number(l.PARTNER_ID) === partnerid && Number(l.OFFER_ID) === Number(offerid) && Number(l.SUB_PROJECT_ID) === Number(projectId)) {
                result.push(l)
              }
              this.totalmain += Number(l.TOTAL_VAT_FEE)
            })
          }
          this.getContractTemplate()
          var resultArr = {}
          var paymentstage = {}
          result.forEach(o => {
            paymentstage = {
              'project_id': null,
              'partner_id': null,
              'contact_id': null,
              'calculation_id': 0,
              'industry_id': null,
              'job_industry_id': null,
              'total': null,
              'totalvat': null,
              'sub_project_id': null,
              'note': null,
              'signature': null,
              'weeks': null,
              'contract_type': 'normal',
              'start_date': null,
              'offer_id': null
            }
            if (resultArr[o.INDUSTRY]) {
              resultArr[o.INDUSTRY].push(o)
            } else {
              resultArr[o.INDUSTRY] = []
              resultArr[o.INDUSTRY].push(o)
            }
            paymentstage = {
              'project_id': o.PROJECT_ID,
              'partner_id': o.PARTNER_ID,
              'contact_id': o.CONTACT_ID,
              'calculation_id': 0,
              'industry_id': o.INDUSTRY,
              'job_industry_id': o.JOB_INDUSTRY,
              'price_total': o.TOTAL,
              'sub_project_id': o.SUB_PROJECT_ID,
              'vat_total': o.TOTALVAT,
              'note': o.NOTE,
              'signature': o.SIGNATURE,
              'weeks': o.WEEKS,
              'contract_type': 'normal',
              'start_date': o.START_DATE,
              'offer_id': o.OFFER_ID,
              'description_payment': []
            }
            if (o.SERIES !== null) {
              Object.values(o.SERIES).forEach((j) => {
                paymentstage['description_payment'].push(j)
              })
            } else {
              o.SERIES = o.SERIES_ORIGINAL
              o.SERIES_ORIGINAL.forEach((j) => {
                paymentstage['description_payment'].push(j)
              })
            }
            this.total += Number(o.TOTALVAT)
            this.paymentStages.push(paymentstage)
          })
          this.getinsuranceamount()
          this.officialEnterpriseArr = resultArr
          // this.getinsuranceamount()
        },
        response => {
          this.loading = false
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    getdataforpriceadd_normal () {
      var datasavePriceEachIndustry = []
      this.officialEnterpriseArr.forEach(industry => {
        var dataSavePrice = {}
        dataSavePrice = {
          project_id: industry.PROJECT_ID,
          contact_id: industry.CONTACT_ID,
          calculation_id: 0,
          industry_id: industry.INDUSTRY,
          total: industry.TOTAL,
          note: industry.NOTE,
          signature: industry.SIGNATURE,
          weeks: industry.WEEKS,
          start_date: industry.START_DATE,
          offer_id: industry.OFFER_ID,
          partner_id: industry.PARTNER_ID
        }
        for (var key in industry.SERIES) {
          if (key !== '' && key !== 'date') {
            dataSavePrice['1_' + key] = industry.SERIES[key]
          }
        }
        for (key in industry.SERIES_TEXT) {
          if (key !== '' && key !== 'date') {
            dataSavePrice[key] = industry.SERIES_TEXT[key]
          }
        }
        datasavePriceEachIndustry.push(dataSavePrice)
      })
      return datasavePriceEachIndustry
    },
    getContractTemplate (contractValue = 100000) {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/ContractInfoV2?contractValue=' + contractValue + '&OfferID=' + this.selectedOfferInfoArr[0].ID + '&wholeEnterprise=0&companyId=' + this.haaid + '&HomeownerID=' + this.currentProjectData.HOMEOWNER.ID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.contractWizardsData.push(res.data.contract)
            this.selectedContractTemplateInfo = res.data.contract
            this.selectedContractTemplateId = res.data.contract.TEMPLATE_ID
            this.getContractWizardSteps()
            this.loading = false
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        },
        response => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    getContractInfo () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/contract/' + this.contractID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          this.contractInfo = res.data
          var latestDocumentInfo = this.contractInfo.DOCUMENTS[this.contractInfo.DOCUMENTS.length - 1]
          this.selectedContractTemplateInfo = this.contractWizardsData
          this.selectedContractTemplateId = this.contractWizardsData[0].TEMPLATE_ID
          this.selectedmainTemplateId = this.contractWizardsData[0].ID
          this.selectedContractTemplateInfo.STEPS = latestDocumentInfo.JSON_STEPS
          this.getContractWizardSteps()
        },
        response => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    async submitcontracteach () {
      for (var subproject in this.paymentStages) {
        var contractsubmit = await this.submitContractInfoeach(this.paymentStages[subproject])
        if (!contractsubmit) {
          return false
        }
      }
      if (!contractsubmit) {
        this.loading = false
        // if (!this.isEditMode) {
        //   this.startIndex = (this.contractWizardStepsData.length + 2) - 1
        // } else {
        //   this.startIndex = this.$route.query.editStep - 1
        // }
        this.$nextTick(() => {
          var wizardTabLists = document.querySelectorAll('#contractWizard .wizard-nav-pills li')
          wizardTabLists.forEach((tabListProp, tabListPropIndex) => {
            tabListProp.querySelector('a').classList.remove('disabled')
            tabListProp.querySelector('.wizard-icon-circle').classList.add('checked')
          })
        })
        return
      }
      var thisvar = this
      let closeFn = function () {
        this.$router.push('/customer-projects/project-dashboard?projectId=' + thisvar.currentProjectData.ID + '&contactID=' + thisvar.selectedOfferInfoArr[0].HOMEOWNER.ID + '&parentID=' + thisvar.parentID + '&industryID=' + thisvar.industryID + '&offertype=' + thisvar.offerType + '&childprojects=' + JSON.stringify(thisvar.childprojects) + '&contracttype=' + thisvar.contractType + '&projecttitle=' + thisvar.currentProjectData.NAME)
      }
      let obj = {
        title: 'Gennemført!',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk',
        onClose: closeFn
      }
      this.$refs.simplert.openSimplert(obj)
    },
    submitContractInfoeach (subproject) {
      return new Promise((resolve, reject) => {
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {
          projectId: subproject.sub_project_id,
          templateId: Number(this.selectedContractTemplateId),
          contractTemplateId: Number(this.selectedmainTemplateId),
          contactId: this.currentProjectData.HOMEOWNER.ID,
          steps: JSON.stringify(this.contractWizardsData[0].STEPS),
          comments: '',
          title: this.currentProjectData.NAME,
          name: this.tab1Form.firstName,
          lastname: this.tab1Form.lastName,
          address: this.tab1Form.address,
          zipcode: this.tab1Form.zip,
          email: this.tab1Form.email,
          mobile: this.tab1Form.telphone.toString(),
          city: this.tab1Form.city,
          parentContractId: this.contractID,
          contractLabel: 'normal',
          source: 'web',
          totalpricewithvatandfee: this.maintotal,
          paymentStages: this.paymentStages
        }
        for (var each in this.STEPactualValue) {
          data[each] = this.STEPactualValue[each]
        }
        this.$http.post(this.$bitrixapi + 'partner/contract', data, { headers }, { emulateJSON: true }).then(
          response => {
            // var res = response.body
            resolve(true)
          },
          response => {
            // reject(false)
            this.$message({
              type: 'error',
              message: response.body.message
            })
          })
      })
    },
    submitContractInfo () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        projectId: this.currentProjectData.ID,
        templateId: Number(this.selectedContractTemplateId),
        contractTemplateId: Number(this.selectedmainTemplateId),
        contactId: this.currentProjectData.HOMEOWNER.ID,
        steps: JSON.stringify(this.contractWizardsData[0].STEPS),
        comments: '',
        title: this.currentProjectData.NAME,
        name: this.tab1Form.firstName,
        lastname: this.tab1Form.lastName,
        address: this.tab1Form.address,
        zipcode: this.tab1Form.zip,
        email: this.tab1Form.email,
        mobile: this.tab1Form.telphone.toString(),
        city: this.tab1Form.city,
        parentContractId: this.contractID,
        contractLabel: 'normal',
        source: 'web',
        totalpricewithvatandfee: this.maintotal,
        paymentStages: this.paymentStages
      }
      for (var each in this.STEPactualValue) {
        data[each] = this.STEPactualValue[each]
      }
      this.$http.post(this.$bitrixapi + 'partner/contract', data, { headers }, { emulateJSON: true }).then(
        response => {
          // var res = response.body
          var m = this
          let closeFn = function () {
            this.$router.push('/customer-projects/project-dashboard?projectId=' + m.currentProjectData.ID + '&contactID=' + m.selectedOfferInfoArr[0].HOMEOWNER.ID + '&parentID=' + m.parentID + '&industryID=' + m.industryID + '&offertype=' + m.offerType + '&childprojects=' + JSON.stringify(m.childprojects) + '&contracttype=' + m.contractType + '&projecttitle=' + m.currentProjectData.NAME)
          }
          let obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk',
            onClose: closeFn
          }
          this.$refs.simplert.openSimplert(obj)
        },
        response => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    contractTemplateChanged () {
      this.loading = true
      this.selectedContractTemplateInfo = this.contractWizardsData.filter((wizardProp) => { return wizardProp.TEMPLATE_ID === this.selectedContractTemplateId })[0]
      this.$refs.contractWizard.changeTab(0, 0)
      this.getContractTemplate()
    },
    wizardChanged (prevIndex, nextIndex) {
      this.activeWizard = nextIndex + 1
    },
    getContractWizardSteps () {
      this.contractWizardStepsData = []
      var step = {}
      step['fields'] = {}
      var templateSteps = this.selectedContractTemplateInfo.STEPS
      for (var steps in templateSteps) {
        step = templateSteps[steps]
        var fieldsData = []
        for (var fields in step.fields) {
          var stepField = step.fields[fields]
          fieldsData.push(stepField)
        }
        step['fields'] = fieldsData
        this.contractWizardStepsData.push(step)
      }
      this.activeWizard = 1
      this.loading = false
    },
    validateDynamicTabs () {
      this.dynamicTabSubmitted = true
      var activeTab = this.$refs.contractDraftWizard
      var activeTabIndex = activeTab.activeTabIndex + 1
      var activeTabElement = document.querySelector('.contractTab-' + activeTabIndex)
      var isTabLastStep = activeTab.isLastStep
      var isFieldsHasNoAnswer = false

      var fields = activeTabElement.querySelectorAll('.fields-id-value.required')
      fields.forEach((fieldProp) => {
        var fieldValue = fieldProp.id.split('_')[1].split('-')[1]
        if (fieldValue === '' || fieldValue === 'null' || fieldValue === 'undefined') {
          isFieldsHasNoAnswer = true
        }
      })
      var valid = null
      if (isFieldsHasNoAnswer) {
        valid = false
      } else {
        valid = true
        this.scrollTo('contractDraftWizard')
      }
      if (isTabLastStep) {
        if (valid) {
          this.loading = true
          this.tab2Form.submitted = false
          this.getValuesSteps()
        }
      }
      return true
    },
    getValuesSteps () {
      var stepsobject = {}
      this.contractWizardStepsData.forEach(item => {
        item.fields.forEach(l => {
          if (l.field_name) {
            stepsobject[l.field_name] = l.default_value
          }
        })
      })
      this.STEPactualValue = stepsobject
      if (this.contractType === 'Fagentreprise') {
        this.submitcontracteach()
      } else {
        this.submitContractInfo()
      }
    },
    calculateFee () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
      }
      var amount = this.total
      // var currency =
      this.$http.post(this.$bitrixapi + 'partner/payproff/calculateFee?amount=' + amount, data, { headers }, { emulateJSON: true }).then(
        response => {
          this.finishWizard()
        },
        err => {
          this.$refs.errorMsg.showMsg(err)
        }
      )
    },
    getinsuranceamount () {
      this.haaid = localStorage.getItem('haaid')
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        totalpriceinclVAT: parseFloat(this.total).toString()
      }
      this.$http.post(this.$bitrixapi + 'integration/InsuranceSettings', data, { headers }, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          if (res.FEEINAMOUNT > 0) {
            this.maintotal = parseInt(this.total) + res.FEEINAMOUNT
          } else {
            this.maintotal = parseInt(this.total)
          }
        },
        response => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    validateTab1 () {
      var error = 0
      this.$refs['wizardtab1'].validate((valid) => {
        if (!valid) {
          error = 1
        }
      })
      if (error === 1) { return false }
      return true
    },
    validateTab2 () {
      return true
    },
    getallwizardproduct () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
      }
      this.$http.get(this.$bitrixapi + 'partner/wizard/all', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          res.forEach(n => {
            this.primaryproductindustryname[n.producttypeid] = n.producttype
          })
        },
        err => {
          var error = err.body.message
          this.$message.error(error)
        })
    },
    scrollTo (elementId) {
      var element = document.getElementById(elementId)
      element.scrollIntoView({behavior: 'smooth'})
    },
    gettaskbitrix () {
      this.$http.get(this.$bitrixapi + 'industries/full', { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var industryname = {}
            res.data.forEach(l => {
              industryname[l.BRANCHE_ID] = l.BRANCHE
            })
            this.itemsjobindustry = industryname
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    }
  }
}
</script>
<style >
  #contract-draft marker {
    background-color: aqua;
  }
  #contract-draft .el-form-item__label {
    font-weight: 600;
    margin-bottom: 0em!important;
  }
  #contract-draft .vue-form-wizard.sm .wizard-icon-circle.checked {
    background-color: #19A3C0!important;
    color: #fff!important;
  }
  #contractDraftWizard .wizard-header {
    display: none;
  }
  #contract-draft .el-input__inner {
    -webkit-appearance: auto;
    border-color: #19A3C0;
  }
  #contractDraftWizard .wizard-icon {
    font-size: 16px;
    font-style: initial!important;
  }
  #contractDraftWizard .vue-form-wizard.sm .wizard-icon-circle {
    width: 40px;
    height: 40px;
  }
  #contractDraftWizard .wizard-progress-with-circle {
    display: block!important;
  }
  #contract-draft .stepTitle {
    position: absolute;
    top: -30px;
    left: 100px;
  }
  #contractDraftWizard .wizard-nav li .stepTitle {
    background-color: none!important;
    border-bottom: none!important;
    padding: 0!important;
  }
  #contractDraftWizard .wizard-nav li .checked+.stepTitle {
    color: #19A3C0!important;
  }
  #contractDraftWizard .vue-form-wizard.lg .wizard-navigation .wizard-progress-with-circle, .vue-form-wizard .wizard-nav-pills {
    display: flex!important;
  }
  #contract-draft .pointer {
    cursor: url(/cursor_1.png) 4 12, auto;
  }
  .font12 {
    font-size: 12px;
  }
  .font14 {
    font-size: 14px;
  }
  #contract-draft .el-textarea.is-disabled .el-textarea__inner {
      background-color: #ffffff;
      border-color: #dfe2e9;
      color: #7d8085;
      cursor: not-allowed;
  }
  .commentdiv {
      height: 900px;
      overflow: auto;
    }
  @media (max-width:27em) {
    .mm0 {
    margin: 0px;
    }
    .mmx-auto {
      margin-left: auto;
      -webkit-box-pack: center;
      justify-content: center;
    }
    .mmb5 {
      margin-bottom: 5rem;
    }
    .mpt1 {
      padding-top: .5rem;
    }
    .mobile-flex-column {
      flex-direction: column!important;
      align-items: center;
    }
    .xs-col-12 {
      width: 100%;
    }
    .mobile-100 {
      width: 100%!important;
    }
    .mp2 {
      padding: 1em;
    }
    .commentdiv {
      height: 750px;
      overflow:auto;
    }
  }
</style>


// WEBPACK FOOTER //
// contract_draft.vue?7ebfe688